import React, { ReactElement } from "react";
import styles from "./Text.module.css";

interface TextProps {
  wrapper?: "h1" | "h2" | "h3" | "h4" | "h4" | "h5" | "span" | "p";
  style?: React.CSSProperties;
  children: React.ReactNode;
  type:
    | "body"
    | "header"
    | "subtitle"
    | "primary_table"
    | "secondary_table"
    | "example"
    | "validation_text"
    | "mandatory_field_text"
    | "user_input_text"
    | "toast_text"
    | "link_text_primary"
    | "link_text_secondary"
    | "table"
    | "error";
  color?: string;
  size?: string;
  id?: string;
}

const Text: React.FC<TextProps> = ({
  wrapper = "p",
  style,
  children,
  type = "body",
  color,
  size,
  id,
  ...rest
}): ReactElement => {
  switch (wrapper) {
    case "h1":
      return (
        <h1 style={{ color, fontSize: size, ...style }} className={styles[type]} id={id} {...rest}>
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2 style={{ color, fontSize: size, ...style }} className={styles[type]} id={id} {...rest}>
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3 style={{ color, fontSize: size, ...style }} className={styles[type]} id={id} {...rest}>
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4 style={{ color, fontSize: size, ...style }} className={styles[type]} id={id} {...rest}>
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5 style={{ color, fontSize: size, ...style }} className={styles[type]} id={id} {...rest}>
          {children}
        </h5>
      );
    case "span":
      return (
        <span
          style={{ color, fontSize: size, ...style }}
          className={styles[type]}
          id={id}
          {...rest}
        >
          {children}
        </span>
      );
    default:
      return (
        <p style={{ color, fontSize: size, ...style }} className={styles[type]} id={id} {...rest}>
          {children}
        </p>
      );
  }
};

export default Text;
